import React, {PureComponent} from 'react';
import classNames from 'classnames/bind';
import moment from "moment";
import * as R from 'ramda';
import {Field as FormField} from 'redux-form';
import {connect} from 'utils/react-redux';
import {Row, Column} from 'components/Grid';

import containerQuery from 'decorators/containerQuery';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Field from 'components/Field';
import FieldPassword from 'components/FieldPassword';
import Text from 'components/Text';
import Title from 'components/Title';
import Info from 'components/Info';
import AvatarPicker from 'components/AvatarPicker';
import RadioGroup from 'components/RadioGroup';
import Link from 'components/Link';
import Checkbox from 'components/Checkbox';
import Select from 'components/Select';
import FieldDate from 'components/FieldDate';
import Editor from "../../components/Editor/EditorConnected";
import FieldComposition from "../FieldComposition";

import styles from './UserForm.module.css';

const cx = classNames.bind(styles);

const radioGroupSex = [
  {
    id: 'radioGroupSexMale',
    value: '1',
    content: 'Мужской',
  },
  {
    id: 'radioGroupSexFemale',
    value: '2',
    content: 'Женский',
  },
];
const mapStateToProps = () => {
  return (state) => {
    const {
      User: { statistic: { deleting } }
    } = state
    return {
      deleting,
    }
  }
}

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;
class UserForm extends PureComponent {
  static propTypes = {
    cities: PropTypes.array,
    containerQuery: PropTypes.object,
    countries: PropTypes.array,
    dirty: PropTypes.bool,
    emptyCities: PropTypes.array,
    step: PropTypes.string,
    valid: PropTypes.bool,
    onReset: PropTypes.func,
    onSubmit: PropTypes.func,
    onExitGroup: PropTypes.func,
    submitting: PropTypes.bool,
    isAccessOpen: PropTypes.bool,
    onAddAccess: PropTypes.func,
    onConfirm: PropTypes.func,
    isLight: PropTypes.bool,
    isConfirmed: PropTypes.bool,
    deleting: PropTypes.bool,
    invite: PropTypes.object,
    countryCurrency: PropTypes.string,
    userIsBalanceda: PropTypes.bool,
  }

  static defaultProps = {
    cities: [],
    containerQuery: PropTypes.object,
    countries: [],
    dirty: false,
    emptyCities: [],
    step: 'registration',
    valid: false,
    onReset: () => { },
    onSubmit: () => { },
    onExitGroup: () => {},
    submitting: false,
    isAccessOpen: false,
    onAddAccess: () => { },
    isLight: false,
    invite: {},
  }
  handlerOnFocusLinkRegistry = (event) => {
    event.target.select()
  }

  renderSupportButton() {
    const { isAccessOpen } = this.props;

    const button = (
      <Button
        size='small'
        color='blue'
        bordered
        onClick={this.props.onAddAccess}
        disabled={isAccessOpen}
      >
        Открыть доступ поддержке
      </Button>
    );

    if (isAccessOpen) {
      return (
        <Info toggler={button}>
          <Text>
            Вы уже дали временный доступ службе поддержки. Дождитесь истечения текущего.
          </Text>
        </Info>
      );
    }

    return button;
  }

  renderForm() {
    const { step, isLight, isPartner, invite: { inviteName, inviteKey }, deleting, countryCurrency, userIsBalanceda } = this.props;
    const isInvite = step === 'invite';
    const isProfile = step === 'profile';
    const isRegistration = step === 'registration';
    const titleByStep = {
      invite: 'Приглашение',
      registration: isMobile ? 'Регистрация' : 'Регистрация пользователя',
    };

    const hasInvite = inviteKey && inviteName;
    const isMobileRegistration = isMobile && isRegistration;

    const consultationFieldsNames = ["custom_первичная_консультация_от", "custom_первичная_консультация_до", "custom_повторная_консультация_от", "custom_повторная_консультация_до", "custom_сопровождение_от", "custom_сопровождение_до"]

    const consultationFields = R.times(i => (
      {
        "labelStatic": i % 2 === 0 ? "от" : "до",
        "name": consultationFieldsNames[i],
        "symbol": countryCurrency,
        "type": "number"
      }
    ), consultationFieldsNames.length);

    const currentYear = moment().year();

    const optionsYearsSelect = R.times(i => {
      const year = currentYear - i;
      return {value: year, label: year.toString()};
    }, 100);

    return (
      <Row>
        {isProfile &&
          <Column small={4} medium={2} big={2} mediumOrder={1} bigOrder={1}>
            <div className={cx('filePicker')}>
              <AvatarPicker
                id='instituteFilePicker'
                name='custom_фото'
                title='Фото'
                fileTitle='Изменить фото'
              />
            </div>
            <hr className={cx('hr')} />
          </Column>
        }
        <Column small={4} medium={isProfile ? 4 : 6} big={isProfile ? 4 : 6}>
          <Row>
            <Column small={4} medium={isProfile ? 4 : 6} big={isProfile ? 4 : 6}>
              {(isRegistration || isInvite) &&
                <div className={cx('title')}>
                  <Title isRegistration>
                    {titleByStep[step]}
                  </Title>
                </div>
              }
            </Column>
            <Column small={4} medium={isProfile ? 4 : 6} big={isProfile ? 4 : 6}>
              <div className={cx('container')}>
                <fieldset className={cx('fieldset')}>
                  <div className={cx('field', {field_registration: isMobileRegistration})}>
                    <Field
                      id='userSurname'
                      name='custom_lastname'
                      label={isMobile ? 'Ваша фамилия' : 'Фамилия'}
                      required={isProfile}
                      isRegistration={isMobileRegistration}
                    />
                  </div>

                  <div className={cx('field', {field_registration: isMobileRegistration})}>
                    <Field
                      id='userFirstName'
                      name='custom_firstname'
                      label='Имя'
                      required={isProfile}
                      isRegistration={isMobileRegistration}
                    />
                  </div>

                  {isProfile &&
                    <div className={cx('field')}>
                      <Field
                        id='userPatron'
                        name='custom_midname'
                        label='Отчество'
                      />
                    </div>
                  }

                  {isProfile &&
                    <Row>
                      <Column small={2} medium={2} big={2}>
                        <div className={cx('select-title')}>
                          <Text color='gray'>Дата рождения</Text>
                        </div>
                        <div className={cx('select-group')}>
                          <FieldDate
                            name='custom_dob'
                          />
                        </div>
                      </Column>
                      <Column small={2} medium={2} big={2}>
                        <div className={cx('radio-title')}>
                          <Text color='gray'>Пол</Text>
                        </div>
                        <RadioGroup
                          name='custom_sexint'
                          items={radioGroupSex}
                        />
                      </Column>
                    </Row>
                  }

                  <div className={cx('field', {field_registration: isMobileRegistration})}>
                    <Field
                      required={isProfile}
                      id='userPhone'
                      name='custom_мобильный_телефон'
                      label={isMobileRegistration ? 'Личный номер телефона' : 'Личный номер мобильного телефона'}
                      placeholder={isMobileRegistration ? '' : 'Поможет хранить данные в безопасности, упростит поддержку'}
                      mask='+??9 (999) 999-99-99'
                      phone={true}
                      isRegistration={isMobileRegistration}
                    />
                    {(isProfile && process.env.REACT_APP_API !== 'dd') &&
                      <FormField
                        name='custom_мобильный_телефон'
                        component={({input, meta}) => (
                          <div className={cx('phone')}>
                            {this.props.isConfirmed && input?.value === this.props.phoneValue || this.props.isConfirmedPhone ?
                              <Text color='green'>
                                подтвержден
                              </Text> :
                              <Button
                                block
                                size='small'
                                bordered
                                disabled={input?.value !== this.props.phoneValue && !this.props.phoneIsValid}
                                onClick={this.props.onConfirm}
                              >
                                Подтвердить
                              </Button>
                            }
                          </div>
                        )}
                      />
                    }
                  </div>
                  {
                    isLight &&
                    <div className={cx('field')}>
                      <Field
                        name='custom_номер_нпа'
                        label='Номер НПА'
                        required={false}
                      />
                    </div>
                  }
                  {!isLight && isProfile &&
                    <div className={cx('field')}>
                      <Field
                        id='userPost'
                        name='custom_должность'
                        label='Должность'
                      />
                    </div>
                  }

                  {isProfile && userIsBalanceda &&
                    <>
                      <Row>
                        <div className={cx('field')}>
                          <Column small={2} medium={2} big={2}>
                            <div style={{display: 'flex'}}>
                              <Field
                                id='userTelegram'
                                name='custom_telegram'
                                label='Telegram username'
                                labelStatic='@'
                              />
                            </div>
                          </Column>
                          <Column small={2} medium={2} big={2}>
                            <Field
                              id='userWhatsapp'
                              name='custom_whatsapp'
                              label='WhatsApp номер'
                              placeholder={''}
                              mask='+??9 (999) 999-99-99'
                              phone={true}
                            />
                          </Column>
                        </div>
                      </Row>
                      <Row>
                        <div className={cx('field')}>
                          <Column small={2} medium={2} big={2}>
                            <Select
                              id='years'
                              name='custom_дата_начала_деятельности'
                              label='Год начала профильной деятельности'
                              options={optionsYearsSelect}
                            />
                          </Column>
                        </div>
                      </Row>
                      <Row>
                        <Column small={4} medium={4} big={4}>
                          <Editor
                            name='custom_опыт'
                            customPlaceholder='Опыт (в свободной форме)'
                            maxLength={10000}
                            hideToolbar
                            isProfilePage
                          />
                        </Column>
                        <Column small={4} medium={4} big={4}>
                          <Editor
                            name='custom_образование'
                            customPlaceholder='Образование'
                            maxLength={10000}
                            hideToolbar
                            isProfilePage
                          />
                        </Column>
                      </Row>
                      <Row>
                        <div className={cx('field')}>
                          <Column small={2} medium={2} big={2}>
                            <FieldComposition
                              isLoggingEqualValues
                              title='Услуги первичной консультации'
                              symbols={consultationFields.slice(0, 2)}
                              compositionIndent
                            />
                          </Column>
                          <Column small={2} medium={2} big={2}>
                            <FieldComposition
                              isLoggingEqualValues
                              title='Услуги повторной консультации'
                              symbols={consultationFields.slice(2, 4)}
                              compositionIndent
                            />
                          </Column>
                        </div>
                      </Row>
                      <Row>
                        <Column small={2} medium={2} big={2}>
                          <div className={cx('field')}>
                            <FieldComposition
                              isLoggingEqualValues
                              title='Услуги сопровождения'
                              symbols={consultationFields.slice(4, 6)}
                              compositionIndent
                            />
                          </div>
                        </Column>
                      </Row>
                    </>
                  }

                  {isProfile &&
                    <>
                      <Row>
                        <Column small={2} medium={2} big={2}>
                          <div className={cx('field')}>
                            <Select
                              id='instituteCity'
                              name='custom_страна'
                              label='Страна'
                              options={this.props.countries}
                              compositionIndent
                            />
                          </div>
                        </Column>
                        <Column small={2} medium={2} big={2}>
                          <div className={cx('field')}>
                            <Select
                              id='instituteCity'
                              name='custom_город'
                              label='Город'
                              disabled={R.isEmpty(this.props.cities)}
                              options={this.props.cities}
                              extraOptions={this.props.emptyCities}
                              alwaysShowExtra
                              onBlurResetsInput
                              minLengthForResult={0}
                              searchable
                            />
                          </div>
                        </Column>
                      </Row>
                    </>
                  }
                  {
                    (isLight && !isRegistration) && hasInvite &&
                    <div className={cx('field')} style={{marginTop: '20px'}}>
                      <Field
                        label='Вы состоите в группе пользователя'
                        value={inviteName}
                        disabled
                      />
                      <FormField
                        name='custom_invite'
                        component={({ input, meta }) => (
                          <div className={cx('phone')}>
                            <Button
                              block
                              isLoading={deleting}
                              size='small'
                              bordered
                              onClick={() => this.props.onExitGroup(inviteKey)}
                            >
                              Выйти
                            </Button>
                          </div>
                        )}
                      />
                    </div>
                  }
                  {!isInvite && !isProfile &&
                    <div className={cx('field', {field_registration: isMobileRegistration})}>
                      <Field
                        id='userEmail'
                        name='custom_login'
                        label='Эл. почта'
                        required={false}
                        disabled={isProfile}
                        placeholder={isMobileRegistration ? '' : 'Будет являться логином для входа на сайт'}
                        isRegistration={isMobileRegistration}
                        additionalText={'Будет являться логином для входа'}
                      />
                    </div>
                  }
                  {isProfile &&
                    <div>
                      <div className={cx('link')}>
                        <Button
                          size='small'
                          to='/user/profile/change-password'
                          color='blue'
                          bordered
                        >
                          Изменить пароль
                        </Button>
                      </div>
                      <div className={cx('link')}>
                        {this.renderSupportButton()}
                      </div>
                    </div>
                  }
                  {(isRegistration || isInvite) &&
                    <div className={cx('field', {field_registration: isMobileRegistration})}>
                      <FieldPassword
                        id='custom_password'
                        name='custom_password'
                        label='Пароль'
                        required={false}
                        placeholder={isMobileRegistration ? '' : 'Не менее 6 символов'}
                        isRegistration={isMobileRegistration}
                      />
                    </div>
                  }
                </fieldset>
              </div>
            </Column>
          </Row>
        </Column>
      </Row>
    );
  }

  renderButtons() {
    const { valid, dirty, step, onReset, submitting } = this.props;
    const isRegistration = step === 'registration';
    const isInvite = step === 'invite';
    const isProfile = step === 'profile';

    const isMobileRegistration = isMobile && isRegistration;

    return (
      <div className={cx('footer')}>
        {!isMobile && <hr className={cx('hr')} />}

        {(isRegistration || isInvite) &&
          <div className={cx('buttons')}>
            <div className={cx('button')}>
              <Button
                id={isRegistration && 'userSignup'}
                type='submit'
                size='big'
                bordered
                disabled={!valid}
                isLoading={submitting}
                customClass={isMobile && 'button--registration'}
              >
                Продолжить
              </Button>
            </div>

            {process.env.REACT_APP_API !== 'dd' &&
              <div className={cx('points')}>
                <Checkbox
                  sizeCheck='small'
                  name='agreement'
                  align='top'
                  theme='dark'
                  isMobile={isMobile}
                >
                  Нажимая кнопку «Продолжить», я даю свое&nbsp;
                  <Link
                    target='_blank'
                    color='inherit'
                    underline
                    hover='blue'
                    href='https://go.nutrilogic.ru/files/consent%20call%20back.pdf'
                    isRegistration={isMobileRegistration}
                  >
                    Согласие на обработку моих персональных данных
                  </Link>
                  &nbsp;в соответствии с&nbsp;
                  <Link
                    target='_blank'
                    color='inherit'
                    underline
                    hover='blue'
                    href='https://go.nutrilogic.ru/files/Privacy%20policy.pdf'
                    isRegistration={isMobileRegistration}
                  >
                    Политикой конфиденциальности.
                  </Link>
                </Checkbox>
                <Checkbox
                  sizeCheck='small'
                  name='privacy'
                  align='top'
                  theme='dark'
                  isMobile={isMobile}
                >
                  Нажимая кнопку «Продолжить», я подтверждаю, что прочитал условия&nbsp;
                  <Link
                    target='_blank'
                    color='inherit'
                    underline
                    hover='blue'
                    href='https://go.nutrilogic.ru/files/User%20agreement.pdf'
                    isRegistration={isMobileRegistration}
                  >
                    Пользовательского соглашения
                  </Link>
                  &nbsp;и настоящим выражаю согласие с ними.
                </Checkbox>
              </div>}
          </div>
        }

        {isProfile &&
          <div className={cx('buttons')}>
            <div className={cx('button')}>
              <Button type='submit' size='big' bordered disabled={!valid}>
                Сохранить
              </Button>
            </div>
            <div className={cx('button')}>
              <Button type='button' size='big' onClick={onReset} bordered disabled={!dirty}>
                Отмена
              </Button>
            </div>
          </div>
        }
      </div>
    );
  }

  render() {
    return (
      <form
        onSubmit={this.props.onSubmit}
        className={cx('userForm', this.props.containerQuery)}
      >
        {this.renderForm()}
        {this.renderButtons()}
      </form>
    );
  }
}

export default R.compose(
  containerQuery(styles),
  connect(mapStateToProps)
)(UserForm);
